<script>
  import {
    DataTable,
    Toolbar,
    ToolbarContent,
    ToolbarSearch,
    Modal,
    Checkbox,
    NumberInput
} from "carbon-components-svelte";
  import { Pagination, Button, TextInput } from "paxray-components-svelte";

  import { isValidRegex } from "../../../../lib/util/regex";
  import { fetchWithSession } from "lib/util/fetchWithSession.js";
  import CopyToClipboardButtons from "../components/CopyToClipboardButtons.svelte";
  import download from "downloadjs";
  import { COPY_ICON, EDIT_ICON, TRASH_ICON } from "@utils/icons.js";

  export let idAnonymization;
  export let editable = false;
  export let preset = false;
  export let currentAnonymizationRule = {};
  export let anonymizationRuleModalOpen = false;
  export let updated = false;

  let anonymizationRules = [];
  let deleteModalOpen = false;
  let deleteId = 0;
  let page = 1;
  let pageSize = 10;
  let filteredRowIds = [];
  let tempRuleName = "";
  let updateRuleName = false;
  let searchValue = "";
  let allRules = [];

  const stored = localStorage.getItem("numberprefix");
  let numberprefix = stored;

  $: if (idAnonymization) {
    loadRules();
  }

  $: if (updated) {
    loadRules();
    updated = false;
  }

  function loadRules() {
    fetchWithSession(
      `/api/damprojects/DAMAnonymizationRules/${idAnonymization}?preset=${preset}`,
    )
      .then((res) => res.json())
      .then((data) => {
        allRules = data;
        anonymizationRules = data;
        console.log({ searchValue });
        applyFilter();
      })
      .catch((err) => console.log(err));
  }

  $: {
    searchValue;
    applyFilter();
  }

  function applyFilter() {
    if (searchValue) {
      anonymizationRules = allRules.filter((item) =>
        Object.values(item).some((val) =>
          String(val).toLowerCase().includes(searchValue.toLowerCase()),
        ),
      );
    } else {
      anonymizationRules = [...allRules];
    }
    filteredRowIds = anonymizationRules.map((item) => item.id);
  }

  $: isSearchInvalid = isValidRegex(currentAnonymizationRule.search);
  $: isReplaceInvalid = isValidRegex(currentAnonymizationRule.replace);

  $: if (updateRuleName) {
    tempRuleName =
      (numberprefix || "") +
      " - " +
      (currentAnonymizationRule.applicationname || "ALL") +
      " - " +
      currentAnonymizationRule.replace;
  }

  $: setCurrentAnonymizationRuleName(tempRuleName);

  function editAnonymizationRule(id) {
    if (id != 0)
      currentAnonymizationRule = anonymizationRules.find((x) => x.id == id);
    else {
      currentAnonymizationRule = {
        id: 0,
        name: "",
        applicationname: "",
        search: "",
        replace: "",
      };
    }
    anonymizationRuleModalOpen = true;
  }

  function setCurrentAnonymizationRuleName(name) {
    currentAnonymizationRule.name = name;
  }

  function copyAnonymizationRule(id) {
    currentAnonymizationRule = {
      ...anonymizationRules.find((x) => x.id == id),
    };
    currentAnonymizationRule.id = 0;
    anonymizationRuleModalOpen = true;
  }

  function saveAnonymizationRule() {
    if (currentAnonymizationRule.name == "") {
      currentAnonymizationRule.name = tempRuleName;
    }
    let payload = {
      idanonymizationrules: idAnonymization,
      ...currentAnonymizationRule,
    };
    console.log(payload);
    fetchWithSession(
      `/api/damprojects/saveDAMAnonymizationRule?preset=${preset}`,
      {
        method: "POST",
        body: JSON.stringify(payload),
      },
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          if (data.id != currentAnonymizationRule.id) {
            currentAnonymizationRule.id = data.id;
            anonymizationRules.push(currentAnonymizationRule);
            anonymizationRules = anonymizationRules;
          } else
            anonymizationRules[
              anonymizationRules.find(
                (x) => x.id == currentAnonymizationRule.id,
              )
            ] = currentAnonymizationRule;
          localStorage.setItem("numberprefix", numberprefix ?? "");
          anonymizationRuleModalOpen = false;
          updated = true;
          updateRuleName = false;
        }
      });
  }

  function deleteAnonymizationRule() {
    fetchWithSession(
      `/api/damprojects/deleteDAMAnonymizationRule/${deleteId}?preset=${preset}`,
      {
        method: "POST",
      },
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          anonymizationRules = anonymizationRules.filter(
            (x) => x.id != deleteId,
          );
          deleteModalOpen = false;
          updated = true;
        }
      });
  }

  let deleteAllModalOpen = false;
  let exportOnDelete = true;

  function exportPreprocessingSteps() {
    fetchWithSession(
      `/api/damprojects/exportDAMAnonymizationRule/` + idAnonymization,
    )
      .then((response) => response.blob())
      .then((data) => {
        download(data, "preprocessing.csv", "text/plain");
      });
  }

  function deleteAllRules() {
    if (exportOnDelete) exportPreprocessingSteps();

    fetchWithSession(
      `/api/damprojects/deleteAllDAMAnonymizationRules/${idAnonymization}`,
      {
        method: "POST",
      },
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          anonymizationRules = [];
          deleteAllModalOpen = false;
          updated = true;
        }
      });
  }
</script>

<div class="table_wrapper">
  <DataTable
    size="short"
    headers={[
      { key: "applicationname", value: "Application" },
      { key: "name", value: "Name" },
      { key: "search", value: "Search" },
      { key: "replace", value: "Replace" },
      { key: "menu", empty: true, width: "150px" },
    ]}
    rows={anonymizationRules}
    sortable
    {page}
    {pageSize}
  >
    {#if editable}
      <Toolbar>
        <ToolbarContent>
          <ToolbarSearch bind:value={searchValue} />
          <div style="padding-right: 0.5rem;">
            <Button
              text="Add Rule"
              kind="secondary"
              on:click={() => {
                editAnonymizationRule(0);
              }}
            />
          </div>
          <Button
            text="Delete All Rules"
            kind="secondary"
            on:click={() => {
              deleteAllModalOpen = true;
            }}
          />
        </ToolbarContent>
      </Toolbar>
    {/if}
    <svelte:fragment slot="cell" let:cell let:row>
      {#if cell.key === "menu" && editable}
        <Button
          size="small"
          kind="secondary"
          icon={EDIT_ICON}
          on:click={editAnonymizationRule(row.id)}
          iconDescription="Edit"
        />
        <Button
          size="small"
          kind="secondary"
          icon={COPY_ICON}
          on:click={copyAnonymizationRule(row.id)}
          iconDescription="Copy"
        />
        <Button
          size="small"
          kind="danger"
          icon={TRASH_ICON}
          on:click={() => {
            deleteId = row.id;
            deleteModalOpen = true;
          }}
          iconDescription="Delete"
        />
      {:else if cell.key !== "menu"}
        {cell.value}
      {/if}
    </svelte:fragment>
  </DataTable>
  <Pagination
    dark
    bind:page
    bind:pageSize
    pageSizes={[10, 25, 50]}
    totalItems={filteredRowIds.length}
  />
</div>

<Modal
  preventCloseOnClickOutside
  size="lg"
  open={anonymizationRuleModalOpen}
  modalHeading="Anonymization Rule"
  primaryButtonText="Save"
  secondaryButtonText="Cancel"
  primaryButtonDisabled={numberprefix === "" || numberprefix === null}
  on:click:button--secondary={() => {
    anonymizationRuleModalOpen = false;
  }}
  on:open={() => {
    if (currentAnonymizationRule.id != 0)
      numberprefix = currentAnonymizationRule.name.split(" - ")[0];
    updateRuleName = true;
  }}
  on:close={() => {
    anonymizationRuleModalOpen = false;
    updateRuleName = false;
  }}
  on:submit={saveAnonymizationRule}
>
  <CopyToClipboardButtons />
  <div class="anonlist-numberprefix">
    <TextInput
      labelText="Prefix"
      placeholder="Enter prefix for rule"
      invalidText="Prefix required"
      bind:value={numberprefix}
    />
  </div>
  <TextInput
    labelText="Name"
    placeholder={tempRuleName}
    bind:value={currentAnonymizationRule.name}
  />
  <TextInput
    labelText="Application"
    placeholder="Enter Application Name (optional)"
    bind:value={currentAnonymizationRule.applicationname}
  />
  <TextInput
    labelText="Search"
    placeholder="Enter Search String (regex allowed)"
    bind:value={currentAnonymizationRule.search}
    invalid={!isSearchInvalid}
    invalidText="Invalid regex"
  />
  <TextInput
    labelText="Replace"
    placeholder="Enter Replacement (regex allowed)"
    bind:value={currentAnonymizationRule.replace}
    invalid={!isReplaceInvalid}
    invalidText="Invalid regex"
  />
</Modal>

<Modal
  size="lg"
  kind="danger"
  open={deleteModalOpen}
  preventCloseOnClickOutside
  modalHeading="Delete Anonymization Rule?"
  primaryButtonText="Delete"
  secondaryButtonText="Cancel"
  on:click:button--secondary={() => {
    deleteModalOpen = false;
  }}
  on:open
  on:close={() => {
    deleteModalOpen = false;
  }}
  on:submit={deleteAnonymizationRule}
>
  Warning: Are you sure you want to delete this rule?
</Modal>

<Modal
  size="lg"
  kind="danger"
  open={deleteAllModalOpen}
  preventCloseOnClickOutside
  modalHeading="Delete All Anonymization Rules?"
  primaryButtonText="Delete"
  secondaryButtonText="Cancel"
  on:click:button--secondary={() => {
    deleteAllModalOpen = false;
  }}
  on:open={() => {
    exportOnDelete = true;
  }}
  on:close={() => {
    deleteAllModalOpen = false;
  }}
  on:submit={deleteAllRules}
>
  Warning: Are you sure you want to delete all rules?
  <br />
  <br />
  <Checkbox
    id="exportOnDelete"
    labelText="Export rules before deleting"
    bind:checked={exportOnDelete}
  />
</Modal>

<style>
  .table_wrapper {
    display: flex;
    flex-direction: column;
  }

  :global(.anonlist-numberprefix .bx--number input[type="number"]) {
    font-family: var(--font-family-inter);
    font-size: var(--cds-body-short-01-font-size, 0.875rem);
    font-weight: var(--cds-body-short-01-font-weight, 400);
    line-height: var(--cds-body-short-01-line-height, 1.28572);
    letter-spacing: var(--cds-body-short-01-letter-spacing, 0.16px);
    outline: 2px solid rgba(0, 0, 0, 0);
    outline-offset: -2px;
    width: 100%;
    height: 2.5rem;
    padding: 0 1rem;
    border: none;
    border-bottom: 1px solid var(--cds-ui-04, #8d8d8d);
    background-color: var(--cds-field-01, #f4f4f4);
    color: var(--cds-text-01, #161616);
    transition:
      background-color 70ms cubic-bezier(0.2, 0, 0.38, 0.9),
      outline 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
  }
</style>
